import { toast } from "react-hot-toast";
import { database } from "../../database.ts";
import { ConfirmDialog } from "../ConfirmDialog/ConfirmDialog.tsx";
import { useGangContext } from "./useGang.ts";

export function StartCampaignDialog() {
  const { gang } = useGangContext();

  return (
    <ConfirmDialog
      heading="Start Campaign?"
      description="The Campaign mode allows you to keep track of your stash, adjust git's attitude, and follows the afterparty rules when adding gits, vehicles, and items."
      submitLabel="Let's go!"
      onSubmit={() => {
        const nextMode = gang.mode.switchToCampaign();
        return database.gangs.updateOne(nextMode.gang.data);
      }}
      onSuccess={() => {
        toast("Ready for campaign!");
      }}
    />
  );
}
